import DeliveryModal from './delivery-modal-component'

export default DeliveryModal
